import React from 'react';
import Box from '@mui/material/Box';
import Helper from '../../utility/helper';
import { useThemeState } from '../../hookState/ThemeState';

const DetailsComponent = (props) => {
    function createMarkup() {
        return {
            __html: props.data
        };
    };
    return (
        <>
            {
                props.data ?

                    <Box sx={{ margin: '10px 10px 10px 5px', backgroundColor: '#fff', border: '1px solid #efefef', borderRadius: '12px', boxShadow: '0 0 2px 0 #919eab3d, 0 16px 32px -4px #919eab3d', width: '98%' }}>
                        <div style={{ padding: '1rem' }} dangerouslySetInnerHTML={createMarkup()} />
                    </Box>
                    : null
            }
        </>
    );
};

export default DetailsComponent;
